import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-file-list-3-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-foreground-900 whitespace-nowrap">
                Basetao Sheet Hub
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Your complete resource for Basetao Spreadsheet guides, templates, shipping calculators, and smart shopping tools.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              Visit Main Website
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4 uppercase tracking-wide">Guides</h4>
            <ul className="space-y-2.5">
              {articles.slice(0, 4).map((article) => (
                <li key={article.slug}>
                  <Link
                    to={`/article/${article.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {article.title.length > 45 ? article.title.substring(0, 42) + '...' : article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Shop Categories */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4 uppercase tracking-wide">Shop Categories</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Shoes</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Hoodies / Sweaters</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">T-Shirts</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Jackets</a>
              </li>
              <li>
                <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors">
                  View All Categories &rarr;
                </Link>
              </li>
            </ul>
          </div>

          {/* Main Site */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4 uppercase tracking-wide">Quick Actions</h4>
            <div className="space-y-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block w-full px-4 py-2.5 text-sm font-semibold text-center text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap"
              >
                Basetao Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block w-full px-4 py-2.5 text-sm font-semibold text-center text-background-50 bg-accent-500 hover:bg-accent-600 rounded-md transition-colors whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Basetao Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Home</Link>
            <Link to="/article/what-is-basetao-spreadsheet" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Guides</Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Main Site</a>
          </div>
        </div>
      </div>
    </footer>
  );
}